import { render, staticRenderFns } from "./editContactModal.vue?vue&type=template&id=0f28b2bd&scoped=true&"
import script from "./editContactModal.vue?vue&type=script&lang=js&"
export * from "./editContactModal.vue?vue&type=script&lang=js&"
import style0 from "./editContactModal.vue?vue&type=style&index=0&id=0f28b2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28b2bd",
  null
  
)

export default component.exports